import { AccessDataProtectionController } from '../controller/AccessDataProtectionController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class AccessDataProtectionComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AccessDataProtectionController,
    });
  }
}
